var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRiskOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.87 416.213L232.508 47.9544C240.149 34.337 259.751 34.337 267.392 47.9544L474.03 416.213C481.511 429.545 471.875 446 456.588 446H43.3117C28.0245 446 18.3892 429.545 25.87 416.213Z",
    stroke: "white",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 163V303",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 382,
    r: 25,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRiskOutline);
export default __webpack_public_path__ + "static/media/ico_risk_outline.8a68aa696e39b64a7ccff3425f7793f2.svg";
export { ForwardRef as ReactComponent };